export default __webpack_public_path__ + "_/shared_modules/PlatformError/images/unplugged-21e8b493d106d850b0f7abaebf52bffc.svg";